export const common = {
  edubox: 'EDUbox',
  talk: 'Talk',
  start: 'Start',
  stop: 'Stop',
  previous: 'Previous',
  next: 'Next',
  error: {
    noConnection: 'Cannot connect to the server',
    invalidRoom: 'Invalid room',
  },
};
